import {Button, Checkbox, Chip, FormControlLabel, TextField, Theme, Typography} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import {FilterValues} from './UserList';

const useStyles = makeStyles((theme: Theme) => ({
    root: {},
    content: {
        padding: theme.spacing(0, 3),
        flexGrow: 1
    },
    contentSection: {
        padding: theme.spacing(2, 0)
    },
    contentSectionHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        cursor: 'pointer'
    },
    contentSectionContent: {},
    formGroup: {
        padding: theme.spacing(2, 0)
    },
    fieldGroup: {
        display: 'flex',
        alignItems: 'center'
    },
    field: {
        marginTop: 0,
        marginBottom: 0
    },
    flexGrow: {
        flexGrow: 1
    },
    addButton: {
        marginLeft: theme.spacing(1)
    },
    tags: {
        marginTop: theme.spacing(1)
    },
    radioGroup: {},
    buttonIcon: {
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(3),
        '& > * + *': {
            marginTop: theme.spacing(2)
        }
    }
}));

export const SearchFilter = (props: { applyFilters: (filters: FilterValues) => void, filters: FilterValues, initialFilters: FilterValues }) => {
    const {filters, initialFilters} = props;
    const classes = useStyles();
    const [values, setValues] = useState({...filters});

    const handleClear = () => {
        props.applyFilters(initialFilters);
    };

    const handleFieldChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
        event.persist();

        setValues(oldValues => ({
            ...oldValues,
            [event.target.name]: event.target.type === 'checkbox' ? (event.target as HTMLInputElement).checked : event.target.value
        }));
    };

    const handleRoleAdd = () => {
        setValues(oldValues => {
            const newValues = {...oldValues};

            if (newValues.role && !newValues.roles.includes(newValues.role)) {
                newValues.roles = [...newValues.roles];
                newValues.roles.push(newValues.role);
            }

            newValues.role = '';

            return newValues;
        });
    };

    const handleRoleDelete = (tag: string) => {
        setValues(oldValues => {
            const newValues = {...oldValues};
            newValues.roles = newValues.roles.filter(t => t !== tag);
            return newValues;
        });
    };

    const applyFilters = () => {
        props.applyFilters(values);
    };

    return (
        <React.Fragment>
            <div className={classes.content}>
                <div className={classes.contentSection}>


                    <div className={classes.formGroup}>
                        <Typography component="p" gutterBottom variant="overline">
                            Email
                        </Typography>
                        <div className={classes.fieldGroup}>
                            <TextField className={classes.field}
                                       fullWidth
                                       label="Email"
                                       name="email"
                                       onChange={handleFieldChange}
                                       value={values.email}
                                       variant="outlined"
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <Typography component="p" gutterBottom variant="overline">Name</Typography>
                        <div className={classes.fieldGroup}>
                            <TextField className={classes.field}
                                       fullWidth
                                       label="First Name"
                                       name="first_name"
                                       onChange={handleFieldChange}
                                       value={values.first_name}
                                       variant="outlined"
                            />
                            <TextField className={classes.field}
                                       fullWidth
                                       label="Last Name"
                                       name="last_name"
                                       onChange={handleFieldChange}
                                       value={values.last_name}
                                       variant="outlined"
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <Typography component="p" gutterBottom variant="overline">Cellphone</Typography>
                        <div className={classes.fieldGroup}>
                            <TextField className={classes.field}
                                       fullWidth
                                       label="Cellphone"
                                       name="cellphone"
                                       onChange={handleFieldChange}
                                       value={values.cellphone}
                                       variant="outlined"
                            />
                        </div>
                    </div>

                    <div className={classes.formGroup}>
                        <Typography component="span" gutterBottom variant="overline" style={{paddingRight: 10}}>Email
                            Verified?</Typography>
                        <FormControlLabel
                            label="yes"
                            control={<Checkbox checked={values.emailVerifiedTrue} onChange={handleFieldChange}
                                               name="emailVerifiedTrue"/>}
                        />
                        <FormControlLabel
                            label="no"
                            control={<Checkbox checked={values.emailVerifiedFalse} onChange={handleFieldChange}
                                               name="emailVerifiedFalse"/>}
                        />
                    </div>

                    <div className={classes.formGroup}>
                        <Typography component="span" gutterBottom variant="overline" style={{paddingRight: 10}}>Admin
                            Verified?</Typography>
                        <FormControlLabel
                            label="yes"
                            control={<Checkbox checked={values.adminVerifiedTrue} onChange={handleFieldChange}
                                               name="adminVerifiedTrue"/>}
                        />
                        <FormControlLabel
                            label="no"
                            control={<Checkbox checked={values.adminVerifiedFalse} onChange={handleFieldChange}
                                               name="adminVerifiedFalse"/>}
                        />
                    </div>

                    <div className={classes.formGroup}>
                        <Typography component="span" gutterBottom variant="overline" style={{paddingRight: 10}}>User
                            Disabled?</Typography>
                        <FormControlLabel
                            label="yes"
                            control={<Checkbox checked={values.disabledTrue} onChange={handleFieldChange}
                                               name="disabledTrue"/>}
                        />
                        <FormControlLabel
                            label="no"
                            control={<Checkbox checked={values.disabledFalse} onChange={handleFieldChange}
                                               name="disabledFalse"/>}
                        />
                    </div>

                    <div className={classes.formGroup} style={{display: 'none'}}>
                        <Typography component="p" gutterBottom variant="overline">
                            Roles
                        </Typography>
                        <div className={classes.fieldGroup}>
                            <TextField
                                className={clsx(classes.field, classes.flexGrow)}
                                label="Role"
                                margin="dense"
                                name="role"
                                onChange={handleFieldChange}
                                value={values.role}
                                variant="outlined"
                                onKeyPress={e => {
                                    if (e.key === 'Enter') handleRoleAdd();
                                }}
                            />
                            <Button
                                className={classes.addButton}
                                onClick={handleRoleAdd}
                                size="small"
                            >
                                <AddIcon/>
                                Add
                            </Button>
                        </div>
                        <div className={classes.tags}>
                            {values.roles.map(role => (
                                <Chip deleteIcon={<CloseIcon/>} key={role} label={role}
                                      onDelete={() => handleRoleDelete(role)}
                                />
                            ))}
                        </div>
                    </div>

                </div>
            </div>
            <div className={classes.actions}>
                <Button id="clear" fullWidth onClick={handleClear} variant="contained">
                    <DeleteIcon className={classes.buttonIcon}/>
                    Clear
                </Button>
                <Button id="submit" color="primary" fullWidth variant="contained" onClick={applyFilters}>
                    Apply filters
                </Button>
            </div>

        </React.Fragment>
    );
};

export default SearchFilter;